import { environment } from '../environments/environment';

export type ZendeskLogLevel = 'log' | 'warn' | 'error';

/**
 * Logger compartilhado dos componentes/serviços do Zendesk.
 * Prefixa as mensagens com o identificador da origem (ex.: 'Zendesk',
 * 'ZendeskService') para facilitar o filtro no console.
 *
 * The step-by-step 'log' trace (user id, visitorId, token steps) only shows outside production;
 * warnings and errors always reach the console.
 */
export function zendeskLog(prefix: string, message: string, level: ZendeskLogLevel = 'log'): void {
  if (level === 'log' && environment.production) {
    return;
  }
  console[level](`${prefix}: ${message}`);
}
